// extracted by mini-css-extract-plugin
module.exports = {"header":"_5131","back":"_10733","content":"_6319","list":"_7894"};